import React, { useState } from "react";
import { useAuth } from "../../context/auth";
import api from "../../services/api";
import Template from "../../template";
import * as S from "./styled";

function MeusEbooks() {
  const { user } = useAuth();
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadEbook = async () => {
    setIsDownloading(true);
    try {
      const response = await api.get("/ebook", {
        responseType: 'blob'
      });
      
      // Criar URL para o blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      
      // Criar elemento de link temporário para download
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'ebook.pdf');
      document.body.appendChild(link);
      link.click();
      
      // Limpar
      link.remove();
      window.URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error('Erro ao baixar e-book:', error);
      
      if (error.response?.status === 403) {
        alert('Você não possui permissão para acessar este e-book.');
      } else if (error.response?.status === 500) {
        alert('Erro interno do servidor. Tente novamente mais tarde.');
      } else {
        alert('Erro ao baixar o e-book. Tente novamente.');
      }
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Template>
      <S.Container>
        <S.Header>
          <S.Title>Meus E-books</S.Title>
        </S.Header>
        
        <S.Content>
          {user.comprou_ebook ? (
            <S.EbookCard>
              <S.EbookImage src="/capa_nota1000.png" alt="E-book da Clara" />
              <S.EbookInfo>
                <S.EbookTitle>E-book da Clara - Nota 1000</S.EbookTitle>
                <S.EbookDescription>
                  Guia completo para alcançar a nota máxima na redação do ENEM.
                  Técnicas, dicas e estratégias comprovadas para o sucesso.
                </S.EbookDescription>
                <S.DownloadButton onClick={handleDownloadEbook} disabled={isDownloading}>
                  {isDownloading ? 'Baixando...' : 'Baixar E-book'}
                </S.DownloadButton>
              </S.EbookInfo>
            </S.EbookCard>
          ) : (
            <S.EmptyState>
              <S.EmptyTitle>Nenhum E-book Adquirido</S.EmptyTitle>
              <S.EmptyDescription>
                Você ainda não possui nenhum e-book em sua biblioteca.
                Explore nossa seção "Comprar E-books" para adquirir conteúdos exclusivos.
              </S.EmptyDescription>
              <S.BuyButton href="/comprar-ebooks">
                Comprar E-books
              </S.BuyButton>
            </S.EmptyState>
          )}
        </S.Content>
      </S.Container>
    </Template>
  );
}

export default MeusEbooks;